import { PerspectiveCamera } from 'three';
import * as THREE from "three";



function createCamera() {
    const camera = new PerspectiveCamera(
        // camera = new THREE.OrthographicCamera(
        45,
        window.innerWidth / window.innerHeight
    );

    camera.position.x = 9;
    camera.position.y = 56;
    camera.position.z = 99;

    camera.lookAt(0, 0, 0);
    return camera;
}

export { createCamera };
